import { render, staticRenderFns } from "./apparatusContact.vue?vue&type=template&id=51486000&scoped=true"
import script from "./apparatusContact.vue?vue&type=script&lang=js"
export * from "./apparatusContact.vue?vue&type=script&lang=js"
import style1 from "./apparatusContact.vue?vue&type=style&index=1&id=51486000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51486000",
  null
  
)

export default component.exports